<template>
    <section id="auth-login" class="row flexbox-container">
        <div class="col-xl-8 col-11">
            <div class="card bg-authentication mb-0">

                <template>
                    <div class="row m-0">
                        <div class="col-md-6 col-12 px-0">
                            <div class="position">
                                <localeChanger></localeChanger>
                            </div>
                            <alert></alert>  
                            <activateBySerialForm></activateBySerialForm>
                        </div>
                        <div class="col-md-6 d-md-block d-none text-center align-self-center p-3">
                            <div class="card-content">
                                <img class="img-fluid" src="/images/pages/login.png" alt="branding logo">
                            </div>
                        </div>
                    </div>  

                </template>
            </div>
        </div>
    </section>
</template>
<script>
    import activateBySerialForm from '@/forms/activateBySerialForm';
    import localeChanger from '@/components/localeChanger'
    import  alert from '@/components/alert';
    export default{
        name: 'activateBySerial',
        components: {
            activateBySerialForm,
            localeChanger,
            alert
        }
    }
</script>
<style>
    .position{
        position: absolute;
        top:0;
        right: 5px;
        z-index: 100;
    }   
</style>